<template>
  <div class="logo-loader" role="status">
    <div class="tile">
      <!-- Butter rises from the bottom with a rolling surface -->
      <div class="fill">
        <svg class="wave wave--back" viewBox="0 0 200 20" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 10 Q25 2 50 10 T100 10 T150 10 T200 10 V20 H0 Z" />
        </svg>
        <svg class="wave wave--front" viewBox="0 0 200 20" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 10 Q25 0 50 10 T100 10 T150 10 T200 10 V20 H0 Z" />
        </svg>
      </div>
      <img class="letters" :src="letters" alt="" width="400" height="400" />
    </div>
    <span class="visually-hidden">Loading</span>
  </div>
</template>

<script>
// SB letters cut out of studio-butter-favicon.png with a transparent background,
// so the butter can rise behind them
import letters from "@/assets/loader/sb-letters.webp";

export default {
  name: "LogoLoader",
  data() {
    return {
      letters,
    };
  },
};
</script>

<style scoped>
.logo-loader {
  --tile: 120px;
  --fill-duration: 1.8s;
}

/* The favicon tile: empty paper with a faint edge until the butter fills it */
.tile {
  position: relative;
  width: var(--tile);
  height: var(--tile);
  overflow: hidden;
  background-color: var(--color-paper);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
}

.fill {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0;
  background-color: var(--color-butter);
  /* Overshoots 100% so the wave crests clear the top and the tile ends fully yellow */
  animation: rise var(--fill-duration) cubic-bezier(0.45, 0, 0.3, 1) forwards;
}

/* Waves are twice the tile's width; sliding by half loops them seamlessly */
.wave {
  position: absolute;
  bottom: calc(100% - 1px);
  left: 0;
  width: 200%;
  height: 14px;
  fill: var(--color-butter);
}

.wave--front {
  animation: slide 1.3s linear infinite;
}

.wave--back {
  bottom: calc(100% + 2px);
  opacity: 0.5;
  animation: slide 2s linear infinite reverse;
}

.letters {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

@keyframes rise {
  from {
    height: 0;
  }
  to {
    height: 115%;
  }
}

@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

/* No motion: show the finished logo */
@media (prefers-reduced-motion: reduce) {
  .fill {
    animation: none;
    height: 100%;
  }

  .wave {
    display: none;
  }
}
</style>
